import React, { useEffect, useState, useRef } from "react";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import "./PackoutNameForm.css";

export default function PackoutNameForm(){
  const [name, setName] = useState("");
  const [editable, setEditable] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const storedName = localStorage.getItem('packoutname');
    if (storedName) {
      setName(storedName);
    } else {
      setName("Packout"); // fallback if code cannot find Name
    }
  }, []);

  const saveName = () => {
    setEditable(false);
    localStorage.setItem('packoutname', name);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        if (editable) saveName();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editable, name]);

  return (
    <div className="form">
      {!editable ? (
        <div style={{ display: "flex", gap: "8px" }}>
          <span className="name-text">{name}</span>
          <IconButton onClick={() => setEditable(true)} aria-label="edit" className="button" size="small">
            <EditIcon className="button" />
          </IconButton>
        </div>
      ) : (
        <input
          ref={inputRef}
          type="text"
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              saveName();
            }
          }}
          style={{ padding: "4px", border: "1px solid gray", borderRadius: "4px" }}
        />
      )}
    </div>
  );
}